import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { LinkProps } from '@unlikelystudio/react-abstract-components'
import Slider from '@unlikelystudio/react-slider'

import InlineCta from '~/components/UI/InlineCta'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type GridListNavProps = {
  className?: string
  links?: LinkProps[]
}

function GridListNav({ className, links }: GridListNavProps) {
  const customSliderRef = useRef()
  const { query } = useRouter()
  const filterValue = query?.uid ?? null
  const isFiltering = !!filterValue

  return (
    <div className={cx(css.GridListNav, className)}>
      <div className={css.wrapper} ref={customSliderRef}>
        <Slider
          className={cx(css.slider)}
          autoIsSlider={true}
          customSliderRef={customSliderRef}>
          {links?.map((link, index) => {
            const isActive =
              index === 0
                ? !isFiltering
                : filterValue &&
                  link.href.toString().indexOf(`${filterValue}`) > -1

            return (
              <InlineCta
                key={`link_right_${index}`}
                className={cx(css.link, { isActive })}
                textPreset={GlobalTextPreset.Cta12Grotesk}
                textStyling={GlobalTextStyling.UpperCase}
                theme={
                  isActive
                    ? GlobalThemeColors.Black
                    : GlobalThemeColors.SilverChalice
                }
                lineProps={{
                  initialLineState: isActive ? 'underlined' : 'none',
                }}
                {...link}
              />
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

GridListNav.defaultProps = {}

export default GridListNav
